import React from 'react';
import '../Colors.css';

const Time = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='HslBlue' d="M763.423 557.333h-292.779v-403.383h86.7v316.683h206.079z"/>
      <path className='HslBlue' d="M513.994 86.693c114.137 0 221.439 44.445 302.142 125.152 80.703 80.703 125.152 188.005 125.152 302.139 0 114.137-44.445 221.439-125.152 302.142-80.703 80.707-188.009 125.152-302.142 125.152s-221.436-44.445-302.142-125.152c-80.703-80.707-125.152-188.009-125.152-302.142s44.448-221.436 125.152-302.139c80.707-80.707 188.009-125.152 302.142-125.152zM513.994-0.007c-283.867 0-513.994 230.12-513.994 513.99 0 283.874 230.127 513.994 513.994 513.994 283.874 0 513.994-230.12 513.994-513.994 0.004-283.87-230.12-513.99-513.994-513.99v0z"/>
      <path className='HslBlue' d="M588.802 512c0 42.416-34.385 76.802-76.802 76.802s-76.802-34.385-76.802-76.802c0-42.416 34.385-76.802 76.802-76.802s76.802 34.385 76.802 76.802z"/>
    </svg>
  );
};

export default Time;